import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import MyPractice from './MyPractice'
import {
  loadPlanEntries,
  changeOrder,
  setInitialFilters,
  clearPlanEntries,
  setDefaultFilter
} from '../../../javascript/redux/actions/planEntries'
import {
  convertFilterByFieldToObject,
  createFilteredStylesObj
} from '../../components_v1/pageLevelComponents/classFinder/classFinderHelperMethods'
import { insertPlanCategories } from '../../../javascript/redux/actions/planCategories'
import { planEntries } from '../../../javascript/redux/selectors/planEntries'

const MyPracticeContents = ({ username, selected_tab, ...props }) => {
  useEffect(() => {
    let stylesFilterObj = createFilteredStylesObj(
      props.dropdownOptions.styles,
      props.preloadedFilters.styles
    )
    let individualStylesObj = {}
    for (const individualFilter in stylesFilterObj) {
      individualStylesObj[individualFilter] =
        stylesFilterObj[individualFilter].filteredSubcategories
    }

    const preFilters = {
      duration: props.preloadedFilters.duration,
      instructors: convertFilterByFieldToObject(
        props.dropdownOptions.instructors || [],
        'slug',
        props.preloadedFilters.instructors
      ),
      difficulties: props.preloadedFilters.difficulties,
      intensities: convertFilterByFieldToObject(
        props.dropdownOptions.intensities,
        'level',
        props.preloadedFilters.intensities
      ),
      equipment: props.preloadedFilters.equipment,
      focus_area: props.preloadedFilters.focus_area,
      excludeCompleted: props.preloadedFilters.excludeCompleted,
      styles: {},
      ...individualStylesObj
    }
    props.insertPlanCategories(props.dropdownOptions.styles)
    props.setInitialFilters(preFilters)
    props.changeOrder(props.defaultOrder || 'date')
    props.clearPlanEntries()
  }, [])
  return (
    <>
      <MyPractice
        username={username}
        selected_tab={selected_tab}
        withSubcategories={props.withSubcategories}
        includeFilters={props.includeFilters}
        preloadedFilters={props.preloadedFilters}
        baseUrl={props.baseUrl}
        dropdownOptions={props.dropdownOptions}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    planEntries: planEntries(state),
    filteredAttributes: state.ui.planEntries.filtered,
    filterUrl: state.ui.planEntries.filterUrl
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadPlanEntries: (callback) => {
      dispatch(loadPlanEntries(callback))
    },
    setInitialFilters: (filters) => {
      dispatch(setInitialFilters(filters))
    },
    changeOrder: (order) => {
      dispatch(changeOrder(order))
    },
    insertPlanCategories: (categories) => {
      dispatch(insertPlanCategories(categories))
    },
    clearPlanEntries: () => {
      dispatch(clearPlanEntries())
    },
    setDefaultFilter: (value) => {
      dispatch(setDefaultFilter(value))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyPracticeContents)
